exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Container[data-v-a9c5a0b0] {\n\toverflow: hidden;\n\ttransition-property: all\n}\n", ""]);

// exports
